































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapActions, mapState } from 'vuex';
import _ from 'lodash';
import OneSignalVue from 'onesignal-vue';

@Component({
    name: 'development',
    computed: {
        ...mapState('auth', ['currentUser']),
    },
})
export default class Development extends Vue {
    private currentUser!: any;

    canSee(roles: any) {
        return _.intersection(roles, [this.currentUser.role.name]).length > 0;
    }

    onLogout() {
        //@ts-ignore
        this.$OneSignal.removeExternalUserId();
        this.$store.dispatch('auth/logout');
    }

    // @Watch('currentUser')
    get userInfo() {
        console.log(this.currentUser);
        //@ts-ignore
        this.$OneSignal.setExternalUserId(this.currentUser.id);
        return true;
    }

    // this.$OneSignal.on('subscriptionChange', function (isSubscribed: any) {
    //     console.log("The user's subscription state is now:", isSubscribed);
    //     // this.$OneSignal.setExternalUserId({ externalUserId: 'TEST'});
    // });
}
